// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_WAVo5","egg":"egg_WCNVc","scale-up-center":"scale-up-center_9-1z-"};